export enum Tpv {
  PAYCOMET = 0,
  LUXON = 1,
}
